<template>
    <span>Good {{ timeOfDay }}</span>
</template>

<script>
export default {
  props: {
    getHours: {
      type: Function,
      default() {
        return new Date().getHours();
      }
    }
  },
  data () {
    return {
      timeOfDay: this.getTimeOfDay()
    };
  },
  methods: {
    getTimeOfDay () {
      const hour = this.getHours();

      if (hour < 12) 
        return 'Morning';
       else if (hour < 18) 
        return 'Afternoon';
       else 
        return 'Evening';
      
    }
  }
};
</script>
